import { FC } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'

import PurchaseCsvExportItem, {
  PurchaseCsvColumn
} from './PurchaseCsvExportItem'

const simNao = (value: boolean) => (value ? 'Sim' : 'Não')

// Uma coluna por valor (nada de "Sim (1 a 3 lotes)" num campo só) para o arquivo ser reimportável
const COLUMNS: PurchaseCsvColumn[] = [
  { header: 'Empresa', field: 'empresaId' },
  { header: 'Usuário Aprovador (E-mail)', field: 'usuarioAprovador' },
  { header: 'De (%)', field: 'minimo' },
  { header: 'Até (%)', field: 'maximo' },
  { header: 'Itens sem recomendação', field: 'itensSemRecomendacao' },
  { header: 'Lotes De', field: 'lotesDe' },
  { header: 'Lotes Até', field: 'lotesAte' }
]

const ActionExcelPurchaseAlcadasExport: FC = () => {
  const { dataAlcadas = [], companieId } = useParametrizationConfigPurchase()

  const getRows = () =>
    dataAlcadas.map(alcada => ({
      empresaId: companieId,
      usuarioAprovador: alcada['user-nome'],
      minimo: alcada['user-de'],
      maximo: alcada['user-ate'],
      itensSemRecomendacao: simNao(alcada.itensSemRecomendacao),
      lotesDe: alcada.itensSemRecomendacao ? alcada.lotesDe : '',
      lotesAte: alcada.itensSemRecomendacao ? alcada.lotesAte : ''
    }))

  return (
    <PurchaseCsvExportItem
      filenamePrefix="alcadas-compra"
      columns={COLUMNS}
      getRows={getRows}
      rowCount={dataAlcadas.length}
    />
  )
}

export default ActionExcelPurchaseAlcadasExport
